let apiRoot = 'https://dev.spnod.com'
let socketRoot = 'wss://dev.spnod.com'
let stripeKey = 'pk_test_yns6XV1kx7DdcwPvMX95ScyO00WerWQHjK'
let spacesRoot = 'https://spnod-test.nyc3.cdn.digitaloceanspaces.com/'

// basic production build option

if (process.env.NODE_ENV === 'production') {
  apiRoot = 'https://app.spnod.com'
  socketRoot = 'wss://app.spnod.com'
  stripeKey = 'pk_live_erJ4k6tAXNUDDpMHkePGg4EC00vHVhLfsA'
  spacesRoot = 'https://spnod.nyc3.cdn.digitaloceanspaces.com/'
}

// if we've added .env files to the vue root
if (process.env.VUE_APP_API_ROOT) {
  apiRoot = process.env.VUE_APP_API_ROOT
}
if (process.env.VUE_APP_SOCKET_ROOT) {
  socketRoot = process.env.VUE_APP_SOCKET_ROOT
}
if (process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY) {
  stripeKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}
if (process.env.SPACES_ROOT) {
  spacesRoot = process.env.SPACES_ROOT
}

export const API_ROOT = apiRoot
export const SOCKET_ROOT = socketRoot
export const IMAGE_PATH = `${API_ROOT}/images`
export const STRIPE_PUBLISHABLE_KEY = stripeKey
export const SPACES_ROOT = spacesRoot



// WEBPACK FOOTER //
// ./src/config.js